import { Route, Routes } from 'react-router-dom';

// import { ApiError } from 'api';
import { NotFound } from 'common/components';

import Filter from './components/Filter';
//import Table from './components/Table';
import { t } from 'i18next';
import { useCallback } from 'react';

const AgentDashboard = () => {
  // const { userId = '' } = useAuth();

  // const userPro = useFetchUser(userId);

  // let user: User = {
  //   id: '',
  //   isConfirmed: false,
  //   email: ''
  // };
  // userPro.then(result => {
  //
  //   user = result.user;
  // })

  const handleSubmit = useCallback(async () => {
    // await changePassword(payload);
    // message.success('Success');
  }, [t]);

  // if (!user) {
  //   return <LoadingScreen />;
  // }

  return (
    <Routes>
      <Route
        element={
          <>
            <Filter isLoading={false} onSubmit={handleSubmit} />
            {/* <Table /> */}
          </>
        }
      >
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AgentDashboard;
